function setMinQuantity() {
  var productHandle = window.ShopifyAnalytics && 
    window.ShopifyAnalytics.meta && 
    window.ShopifyAnalytics.meta.product && 
    window.ShopifyAnalytics.meta.product.handle;

  if (productHandle !== 'tarjetas-de-visita-personalizadas') return;

  // Dawn usa varios selectores posibles
  var selectors = [
    'input[name="quantity"]',
    '.quantity__input',
    'input.quantity',
    '[data-quantity-input]'
  ];

  var qtyInput = null;
  for (var i = 0; i < selectors.length; i++) {
    qtyInput = document.querySelector(selectors[i]);
    if (qtyInput) break;
  }

  if (qtyInput) {
    qtyInput.setAttribute('min', '50');
    if (parseInt(qtyInput.value) < 50) {
      qtyInput.value = 50;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

// Intentar al cargar y también con un pequeño delay
document.addEventListener('DOMContentLoaded', function() {
  setMinQuantity();
  setTimeout(setMinQuantity, 500);
  setTimeout(setMinQuantity, 1500);
});
